import { DatePipe } from "@angular/common";
import { NgModule } from "@angular/core";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { TranslateModule } from "@ngx-translate/core";
import { IonicPageModule } from "ionic-angular";
import { CommonComponentsModule } from "../../../components/common/common-components.module";
import { VerbalCertificationForm } from "./verbal-certification-form";

@NgModule({
  declarations: [VerbalCertificationForm],
  exports: [VerbalCertificationForm],
  imports: [
    CommonComponentsModule,
    TranslateModule.forChild(),
    IonicPageModule.forChild(VerbalCertificationForm),
    FontAwesomeModule,
  ],
  providers: [DatePipe],
})
export class VerbalCertificationFormModule {}



// WEBPACK FOOTER //
// ./src/certification/forms/verbal-certification-form/verbal-certification-form.module.ts